import { useEffect, useState } from 'react';
import axios from 'axios';
import { PipelineStage } from '../types';
import { env } from '../env';

const API_BASE_URL = env.REACT_APP_API_URL || 'http://127.0.0.1:5001';

export function usePipelineStages(): [PipelineStage[], boolean, any] {
  const [stages, setStages] = useState<PipelineStage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    async function fetchStages() {
      setLoading(true);
      try {
        const response = await axios.get(`${API_BASE_URL}/api/pipeline/stages`);
        // Accepts either array of [code, name] or array of objects
        let data = response.data;
        if (Array.isArray(data)) {
          setStages(data.map((s: any) => Array.isArray(s) ? { code: s[0], name: s[1] } : s));
        } else if (Array.isArray(data.stages)) {
          setStages(data.stages.map((s: any) => Array.isArray(s) ? { code: s[0], name: s[1] } : s));
        } else {
          setStages([]);
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    }
    fetchStages();
  }, []);

  return [stages, loading, error];
}
